/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import {
    RouteActions,
    InputActions,
    OutputActions,
    UtilityActions
} from 'app/redux/actions.js';

function mapStateToProps(state) {
    return({
        automatedRoutes: state.automatedRoutes
    });
}

function mapDispatchToProps(dispatch) {
    return {
        getRoutes: () => {
            dispatch(RouteActions.fetchRoutes());
        },
        getRoute: (id) => {
            dispatch(RouteActions.fetchRoute(id));
        },
        updateRoute: (input) => {
            dispatch(RouteActions.updateRoute(input));
        },
        deleteRoute: (id) => {
            dispatch(RouteActions.deleteRoute(id));
        },
        createRoute: (route) => {
            dispatch(RouteActions.createRoute(route));
        },
        getInput: (id) => {
            dispatch(InputActions.fetchInput(id));
        },
        updateInput: (input) => {
            dispatch(InputActions.updateInput(input));
        },
        deleteInput: (id) => {
            dispatch(InputActions.deleteInput(id));
        },
        createInput: (input) => {
            dispatch(InputActions.createInput(input));
        },
        validateInput: (input) => {
            dispatch(InputActions.validateInput(input));
        },
        clearValidatedInputs: () => {
            dispatch(InputActions.clearValidatedInputs());
        },
        fetchInputLog: (id) => {
            dispatch(InputActions.fetchInputLog(id));
        },
        refreshInput: (id) => {
            dispatch(InputActions.refreshInput(id));
        },
        getSocialInputCreds: () => {
            dispatch(InputActions.fetchSocialInputCreds());
        },
        getOutput: (id) => {
            dispatch(OutputActions.fetchOutput(id));
        },
        updateOutput: (output) => {
            dispatch(OutputActions.updateOutput(output));
        },
        deleteOutput: (id) => {
            dispatch(OutputActions.deleteOutput(id));
        },
        createOutput: (output) => {
            dispatch(OutputActions.createOutput(output));
        }
	};
}

export default function RouteProvider(Component) {

    class RouteComponent extends React.Component {
        constructor(props) {
            super(props);

            this.findRoute = this.findRoute.bind(this);
            this.findInput = this.findInput.bind(this);
            this.findOutput = this.findOutput.bind(this);

        }

        findRoute(id, source) {
            let route = null;

            if (!source) {
                source = this.props;
            }

            for (let i = 0; i < source.automatedRoutes.list.length; ++i) {
                if (parseInt(id, 10) === parseInt(source.automatedRoutes.list[i].id, 10)) {
                    route = source.automatedRoutes.list[i];
                    break;
                }
            }

            return route;
        }

        findInput(id, source) {
            let route = null,
                input = null;

            if (!source) {
                source = this.props;
            }

            for (let i = 0; i < source.automatedRoutes.list.length; ++i) {
                route = source.automatedRoutes.list[i];
                for (let j = 0; j < route.inputs.length; ++j) {
                    if (parseInt(id, 10) === parseInt(route.inputs[j].id, 10)) {
                        input = route.inputs[j];
                        break;
                    }
                }
                if (input !== null) {
                    break;
                }
            }

            return input;

        }

        findOutput(id, source) {

            let route = null,
                output = null;

            for (let i = 0; i < source.automatedRoutes.list.length; ++i) {
                route = source.automatedRoutes.list[i];
                for (let j = 0; j < route.outputs.length; ++j) {
                    if (parseInt(id, 10) === parseInt(route.outputs[j].id, 10)) {
                        output = route.outputs[j];
                        break;
                    }
                }
                if (output !== null) {
                    break;
                }
            }

            return output;

        }

        render() {
            return (
                <Component
                    findRoute={this.findRoute}
                    findInput={this.findInput}
                    findOutput={this.findOutput}
                    {...this.props}/>
            );
        }
    }

    RouteComponent.displayName = "RouteComponent";

    return connect(mapStateToProps, mapDispatchToProps)(RouteComponent);
};
